import { useMutation, useQuery } from '@tanstack/react-query'
import { getUserDetails, getUserList, updateUserStatus } from '../api/users'

// Users
export const useGetUserList = (queryParams = '') => {
    return useQuery({
        queryKey: ['users', queryParams],
        queryFn: () => getUserList(queryParams)
    });
};

export const useGetUserDetails = (queryParams = '') => {
    return useQuery({
        queryKey: ['user', queryParams],
        queryFn: () => getUserDetails(queryParams),
        enabled: !!queryParams
    });
};

export const useUpdateUserStatus = () => {
    return useMutation({
        mutationFn: updateUserStatus
    })
};